import React, { FC, memo } from 'react'
import { Tooltip as TooltipAnt } from 'antd'
import { i18n, UIPlacement } from 'LibNeo'

export interface TooltipProps {
	title?: string | JSX.Element
	className?: string
	placement?: UIPlacement
	defaultVisible?: boolean
}

export const TooltipComponent: FC<TooltipProps> = memo(
	({ title, children, placement, defaultVisible }) => {
		const tooltipText = typeof title === 'string' ? i18n(title) : title

		return (
			<TooltipAnt defaultVisible={defaultVisible} title={tooltipText} placement={placement}>
				{children}
			</TooltipAnt>
		)
	}
)
